import * as api from "../constants/apiEndpoints";
import fetchival from "fetchival";
import axios from "axios";
import request from "sync-request";
import {
  APPLICATION_JSON_CONTENT_TYPE,
  DELETE,
  GET,
  MULTIPART_FORM_DATA_CONTENT_TYPE,
  POST,
  PUT
} from "../constants/postMessages";
import {clearStorage, getSessionToken} from "../actions/storage";

let isSessionChecked = false;

export const isSessionTerminated = (session) => {
  let response = request(GET, api.GET_CUSTOMIZATION(), {
    headers: {
      'x-imp-session-token': session,
    }
  });
  if (response.statusCode === 403) {
    clearStorage();
    return true;
  } else {
    return false;
  }
}

/* Auth */
export const authApi = (authToken, idpInstanceId, applianceUuid, capabilities) => {
  return fetchival(api.AUTH).post({
    authToken,
    idpInstanceId,
    applianceUuid,
    capabilities
  })
}

export const checkSession = (history) => {
  if (!isSessionChecked) {
    isSessionChecked = true;
    history.push({
          pathname: '/auth',
          state: {previousPage: history.location.pathname}
        }
    );
    return false;
  } else {
    return true;
  }
}

/* Service Provider */
export const importUrlApi = (parseUrl) => {
  return fetchival(api.PARSE_FROM_URL(), {
    headers: {
      "x-imp-session-token": getSessionToken(),
    }
  }).post({
    parseUrl
  })
}

export const generateOidcClientCredentialsApi = (appId) => {
  return fetchival(api.GENERATE_OIDC_CLIENT_CREDENTIALS(appId), {
    headers: {
      "x-imp-session-token": getSessionToken(),
    }
  }).get()
}

export const addSpApi = (newMeta) => {
  return fetchival(api.ADD_SP(), {
    headers: {
      "x-imp-session-token": getSessionToken(),
    }
  }).post(newMeta)
}

export const updateAppApi = (applicationId, newMeta) => {
  return fetch(api.UPDATE_APP(applicationId), {
    method: PUT,
    headers: {
      "Content-Type": APPLICATION_JSON_CONTENT_TYPE,
      "x-imp-session-token": getSessionToken()
    },
    body: JSON.stringify(newMeta)
  }).then(function (response) {
    if (response.ok) {
      return response;
    }
    let err = new Error(response.statusText)
    err.response = response
    throw err
  })
}

export const startUsingNewIdpCertificateApi = (applicationId) => {
  return fetchival(api.NEW_IDP_CERT_APP(applicationId), {
    headers: {
      "x-imp-session-token": getSessionToken()
    }
  }).put({})
}

export const getAppApi = (applicationId) => {
  return fetchival(api.GET_APP(applicationId), {
    headers: {
      "x-imp-session-token": getSessionToken(),
    }
  }).get()
}

export const importFromXmlApi = (data) => {
  return fetch(api.PARSE_FROM_XML(), {
    method: POST,
    body: data,
    headers: {
      "x-imp-session-token": getSessionToken(),
    }
  }).then(function (response) {
    if (response.status >= 200 && response.status < 400) {
      return response.json()
    }
    let err = new Error(response.statusText)
    err.response = response
    throw err
  })
}

export const deleteAppsApi = (data) => {
  return fetch(api.DELETE_APPS(), {
    method: DELETE,
    body: JSON.stringify(data),
    headers: {
      "Content-Type": APPLICATION_JSON_CONTENT_TYPE,
      "x-imp-session-token": getSessionToken(),
    }
  })
}

export const deleteAppApi = (appId) => {
  return fetch(api.DELETE_APP(appId), {
    method: DELETE,
    headers: {
      "x-imp-session-token": getSessionToken(),
    }
  })
}

export const checkAppExistApi = (appId) => {
  return fetch(api.GET_APP(appId), {
    headers: {
      "x-imp-session-token": getSessionToken()
    }
  })
}

export const getAppsListApi = () => {
  return fetch(api.GET_APP_LIST(), {
    headers: {
      "x-imp-session-token": getSessionToken()
    }
  })
}

/* Logout */
export const logoutApi = () => {
  return fetchival(api.LOGOUT, {
    headers: {
      "x-imp-session-token": getSessionToken(),
    }
  }).get()
}

/* Idp */
export const getIdpMetadataApi = (appId) => {
  return fetchival(api.GET_IDP_METADATA(appId), {
    headers: {
      'x-imp-session-token': getSessionToken(),
      'Cache-Control': 'no-cache, no-store'
    }
  }).get()
}

/* OIDC Idp */
export const getOidcIdpMetadataApi = (oidcIdpMetadataUrl) => {
  return fetchival(oidcIdpMetadataUrl, {
    headers: {
      'Cache-Control': 'no-cache, no-store'
    }
  }).get()
}

/* Customization */
export const saveCustomizationApi = (formData) => {
  return axios.post(api.SAVE_CUSTOMIZATION(), formData, {
    headers: {
      'Content-Type': MULTIPART_FORM_DATA_CONTENT_TYPE,
      'x-imp-session-token': getSessionToken(),
    },
  })
}

export const getCustomizationApi = () => {
  return fetchival(api.GET_CUSTOMIZATION(), {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'x-imp-session-token': getSessionToken(),
    }
  }).get()
}

/* Azure AD */
export const addAzureAdApi = (azureData) => {
  return fetchival(api.AZURE_AD(), {
    headers: {
      "x-imp-session-token": getSessionToken(),
    }
  }).post(azureData);
}

export const deleteAzureAdApi = (id) => {
  return fetch(api.DELETE_AZURE_AD(id), {
    method: DELETE,
    headers: {
      "x-imp-session-token": getSessionToken(),
    }
  })
}

export const getAzureAdListApi = () => {
  return fetchival(api.GET_AZURE_AD_LIST(), {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'x-imp-session-token': getSessionToken(),
    }
  }).get()
}

export const getAzureAdJsonApi = () => {
  return fetchival(api.GET_AZURE_AD_JSON(), {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'x-imp-session-token': getSessionToken(),
    }
  }).get()
}

export const getWorkflowsApi = () => {
  return fetchival(api.GET_WORKFLOWS(), {
    headers: {
      'Cache-Control': 'no-cache, no-store',
      'x-imp-session-token': getSessionToken(),
    }
  }).get()
}

export const getPredefinedAcrWorkflowApi = () => {
  return fetchival(api.GET_PREDEFINED_OIDC_ACR(), {
    headers: {
      'Cache-Control': 'no-cache, no-store',
      'x-imp-session-token': getSessionToken(),
    }
  }).get()
}